<template>
  <div class="detial-cont-view">
    <a-descriptions layout="vertical">
      <a-descriptions-item>
        <span slot="label">部门/单位名称 <span class="required">*</span></span>
        <a-tree-select
          disabled
          v-model="form.organizationId"
          class="w300"
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
          :tree-data="app.organizeList"
          @change="changeEmitFn"
          placeholder="请选择部门/单位"
          tree-default-expand-all
          :replaceFields="{
            key: 'id',
            value: 'id',
            children: 'treeList',
            title: 'organizationName'
          }"
        >
        </a-tree-select>
      </a-descriptions-item>
      <a-descriptions-item>
        <span slot="label">收款人<span class="required">*</span></span>
        <a-input
          class="w300"
          placeholder="请输入收款人姓名"
          v-model="form.collectionName"
          :disabled="disabled"
          @change="changeEmitFn"
        />
      </a-descriptions-item>
      <a-descriptions-item>
        <span slot="label">费用报销日期<span class="required">*</span></span>
        <!--  -->
        <a-date-picker
          allowClear
          class="w300"
          v-model="form.applyTime"
          valueFormat="YYYY-MM-DD"
          @change="changeEmitFn"
          :disabled="disabled"
        />
      </a-descriptions-item>
      <a-descriptions-item>
        <span slot="label">付款方式<span class="required">*</span></span>
        <a-select
          class="w300"
          placeholder="请输入你的付款方式"
          v-model="form.paymentMethod"
          :disabled="disabled"
          @change="changePaywayFn"
        >
          <template v-for="(item, index) in bytype.paymentwayValList">
            <a-select-option :value="item.valuename" :key="index">{{
              item.keyname
            }}</a-select-option>
          </template>
        </a-select>
      </a-descriptions-item>
      <a-descriptions-item label="其他付款方式" v-if="otherPayway">
        <a-input
          class="w300"
          placeholder="请注明其他付款方式"
          v-model="form.paymentMethodName"
          :disabled="disabled"
          @change="changeEmitFn"
        />
      </a-descriptions-item>
      <a-descriptions-item>
        <span slot="label">收款单位名称<span class="required">*</span></span>
        <a-input
          class="w300"
          placeholder="请输入单位名称"
          v-model="form.collectionCompanyName"
          :disabled="disabled"
          @change="changeEmitFn"
        />
      </a-descriptions-item>
      <a-descriptions-item>
        <span slot="label">收款单位账号<span class="required">*</span></span
        ><a-input
          class="w300"
          placeholder="请输入账号"
          v-model="form.collectionCompanyNumber"
          :disabled="disabled"
          @change="changeEmitFn()"
        />
      </a-descriptions-item>
      <a-descriptions-item>
        <span slot="label">开户银行<span class="required">*</span></span>
        <a-input
          class="w300"
          placeholder="请输入开户银行"
          v-model="form.bank"
          :disabled="disabled"
          @change="changeEmitFn"
        />
      </a-descriptions-item>
      <a-descriptions-item label="地址">
        <a-input
          class="w300"
          placeholder="请输入地址"
          v-model="form.address"
          :disabled="disabled"
          @change="changeEmitFn"
        />
      </a-descriptions-item>
      <a-descriptions-item label="电话">
        <a-input
          class="w300"
          placeholder="请输入手机号码"
          v-model="form.phoneNumber"
          :disabled="disabled"
          @blur="changePhoneNumber()"
        />
      </a-descriptions-item>
      <a-descriptions-item>
        <span slot="label"
          >合计金额（小写）<span class="required">*</span></span
        >
        <a-input-number
          :min="0"
          :max="99999999999999999999"
          class="w300"
          placeholder="请输入金额"
          v-model="form.fee"
          :disabled="disabled"
          @change="changeTotalFee()"
        />
      </a-descriptions-item>
      <a-descriptions-item>
        <span slot="label"
          >合计金额（大写）<span class="required">*</span></span
        >
        <a-input
          class="w300"
          placeholder="金额（大写）"
          v-model="totalFeeCapitalize"
          :disabled="true"
        />
      </a-descriptions-item>
      <a-descriptions-item>
        <span slot="label"
          >原始凭单粘贴簿（或附件）张数<span class="required">*</span></span
        >
        <a-input-number
          :min="0"
          :max="1000000"
          class="w300"
          placeholder="请输入张数"
          v-model="form.enableNum"
          :disabled="disabled"
          @change="changeEmitFn"
        />
      </a-descriptions-item>
      <a-descriptions-item label="备注">
        <a-input
          class="w300"
          placeholder="请添加"
          v-model="form.remark"
          :disabled="disabled"
          @change="changeEmitFn"
        />
      </a-descriptions-item>
    </a-descriptions>
  </div>
</template>
<script>
import { priceChange } from '@/utils/utils'
import { mapState, mapActions, mapMutations } from 'vuex'
import { validatorPhone } from '@/assets/js/auth'

export default {
  props: ['disabled', 'resDetail', 'formInfo'],
  model: {
    event: 'input',
    prop: 'formInfo'
  },
  data() {
    return {
      form: {},
      organizationIds: [],
      totalFeeCapitalize: '',
      otherPayway: false
    }
  },
  watch: {
    resDetail(val) {
      if (val) {
        this.form = val
        this.organizationIds = val.organizationIds
        this.totalFeeCapitalize = priceChange(this.form.totalFee)
      }
    }
  },
  computed: {
    ...mapState(['app', 'bytype'])
  },
  created() {
    this.getorganizeListFn()
    this.getpaymentwayVal()
  },
  mounted() {
    if (this.resDetail) {
      this.form = this.resDetail
      this.organizationIds = this.resDetail.organizationIds
      this.totalFeeCapitalize = priceChange(this.form.totalFee)
    } else {
      this.form.organizationId = this.$store.state.app.organizationId
    }
  },
  methods: {
    ...mapActions(['getorganizeListFn', 'getpaymentwayVal']),
    // 更改付款方式
    changePaywayFn() {
      if (this.form.paymentMethod == '1799') {
        this.otherPayway = true
      } else {
        this.otherPayway = false
      }
    },
    // 选择部门、单位
    changeOrganization(value, selectedOptions) {
      if (value.length != 0) {
        this.form.organizationId = value.pop()
      } else {
        this.form.organizationId = ''
      }
      this.changeEmitFn()
    },
    // 输入合计金额小写
    changeTotalFee() {
      this.totalFeeCapitalize = priceChange(this.form.fee)
      this.form.totalFee = priceChange(this.form.fee)
      this.$emit('input', this.form)
    },
    changeEmitFn() {
      this.$emit('input', this.form)
    },
    changePhoneNumber() {
      let isPhone = validatorPhone(this.form.phoneNumber)
      if (!this.form.phoneNumber) {
        return
      }
      if (isPhone) {
        this.$emit('input', this.form)
      } else {
        this.form.phoneNumber = ''
        this.$message.error('请输入正确的手机号！')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.detial-cont-view {
  background: #fff;
  padding: 30px;
  .accessory-btn {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/DuesClaimExpense/components/formBaseInfo.vue